import { Uuid } from "@/domains/global/identifiers";
import { api } from "@/modules/api";
import { useQuery } from "@tanstack/react-query";

import { FC } from "react";
import { useParams } from "react-router";

export const AppCalloutsViewPage: FC = () => {
  const { appCalloutId } = useParams<{ appCalloutId: Uuid }>();

  if (!appCalloutId) {
    return <div>Invalid ID</div>;
  }

  const result = useQuery({
    queryKey: ["app-callout-by-id", appCalloutId],
    queryFn: () =>
      api.get("/internal/v1/app-callouts/{app_callout_id}", {
        params: {
          path: {
            app_callout_id: appCalloutId,
          },
        },
      }),
  });

  return (
    <div>
      <h1>View App Callout</h1>
      <pre>{JSON.stringify(result.data, null, 2)}</pre>
    </div>
  );
};
